import React, { useMemo } from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { formatTimestamp } from "../../hooks/time-buckets";

export default function LineChartWidget({ data, granularity, color = "#6366f1", fullscreen }) {
    if (!data || data.length === 0) {
        return <div className="empty-chart">No data</div>;
    }

    const gradId = useMemo(() => `lineGrad-${Math.random().toString(36).slice(2, 9)}`, []);

    return (
        <ResponsiveContainer width="100%" height={fullscreen ? "100%" : 200}>
            <AreaChart data={data} isAnimationActive={false}>
                <defs>
                    <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={color} stopOpacity={0.25} />
                        <stop offset="95%" stopColor={color} stopOpacity={0} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis
                    dataKey="timestamp"
                    tickFormatter={(ts) => formatTimestamp(ts, granularity)}
                    tick={{ fontSize: 11 }}
                    stroke="#94a3b8"
                />
                <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <Tooltip
                    labelFormatter={(ts) => new Date(ts).toLocaleString()}
                    formatter={(v) => [Number(v).toFixed(2), "Value"]}
                />
                <Area
                    type="monotone"
                    dataKey="value"
                    stroke={color}
                    strokeWidth={2}
                    fill={`url(#${gradId})`}
                    fillOpacity={1}
                    isAnimationActive={false}
                    dot={false}
                    activeDot={{ r: 4 }}
                />
            </AreaChart>
        </ResponsiveContainer>
    );
}
